import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    active: { type: Boolean, default: false },
    interval: { type: Number, default: 2000 }
  }

  connect() {
    if (this.activeValue) this.start()
  }

  disconnect() {
    this.stop()
  }

  start() {
    this.stop()
    this.timer = window.setInterval(() => this.refresh(), this.intervalValue)
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer)
    this.timer = null
  }

  async refresh() {
    const response = await fetch(this.urlValue, {
      headers: { Accept: "text/vnd.turbo-stream.html" }
    })
    if (!response.ok) return

    const html = await response.text()
    window.Turbo.renderStreamMessage(html)
  }
}
